module.exports = __webpack_public_path__ + "img/f1-2-1.ba0e5471.png";